/**
 * learnerEvents — fire-and-forget event emission for learner telemetry.
 *
 * All events are POSTed to <API_BASE>/learner/events, the same base the
 * axios client in api.js uses (/scenario-os by default). The learner UI's
 * nginx only proxies /scenario-os/; an /api/scenario-os/ path falls through
 * to the static SPA, which answers POST with 405.
 * Failures are silently swallowed so analytics never block the UI.
 *
 * Event types used across the platform:
 *   scene_viewed        — { scene_id, domain, tutorial_id, duration_ms? }
 *   overlay_answered    — { marker_id, is_correct, attempts, time_to_answer_ms }
 *   overlay_skipped     — { marker_id, time_to_answer_ms }
 *   video_paused        — { timestamp_ms }
 *   video_replayed      — { from_ms, to_ms }
 */

const API_BASE = (process.env.REACT_APP_SCENARIO_OS_API || '/scenario-os').replace(/\/$/, '');

export async function emitLearnerEvent(eventData) {
  try {
    const token =
      localStorage.getItem('scenario_os_token') ||
      sessionStorage.getItem('scenario_os_token');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    await fetch(`${API_BASE}/learner/events`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ ...eventData, created_at: new Date().toISOString() }),
    });
  } catch (_e) {
    // fire-and-forget — analytics must never block the UI
  }
}
